<script lang="ts">
  export let key: string;
  export let value: any;
  export let stats: any;

  import PrintVal from "./PrintVal.svelte";

  /*
    numbers are numbers, but booleans are as string (AB constraint)
  */
</script>

{#if key === 'canesFromLib'}
  {#if value === 1}
    <PrintVal {value} /> cane from this paperweight exists in real world paperweights.
  {:else if value > 0}
    <PrintVal {value} /> canes from this paperweight exist in real world paperweights.
  {:else}
    <PrintVal {value} />: no cane from this paperweight exists in real world paperweights.
  {/if}
{:else if key === 'randomCanes'}
  <PrintVal {value} /> canes are generated randomly.
{:else if key === 'layoutType'}
  The general layout of the paperweight is <PrintVal {value} />.
{:else if key === 'generalStyle'}
  {#if value === 'allMixed'}
    <PrintVal {value} />: no specific style is favored, each cane has a random style
  {:else}
    <PrintVal {value} /> styled canes are favored:
    {#if value === 'cogs'}
      cogwheel like canes, very angular (which is very typical of Murano).
    {:else if value === 'smoothCogs'}
      cogwheel like canes, with smooth angles.
    {:else if value === 'pinchedCircles'}
      canes like a cog, but each teeth looks like the part of a circle.
    {:else if value === 'simpleCircles'}
      canes made of concentric circles.
    {/if}
  {/if}  
{:else if key === 'simplestCane'}
  The simplest cane is made of <PrintVal {value} /> elements.
{:else if key === 'mostComplexCane'}
  The most complex cane is made of <PrintVal {value} /> elements.
{:else if key === 'hasCentralCane'}
  <PrintVal {value} /> -
  {#if value}
    the paperweight has a central cane (in the very center).
  {:else}
    there is no central cane.
  {/if}
{:else if key === 'numberOfCanes'}
  The total number of canes is <PrintVal {value} />.
{:else if key === 'caneSetType'}
  <PrintVal {value} />:
  {#if value === 'allDifferent'}
    all the canes are different (each is unique).
  {:else if value === 'classic'}
    most canes are present multiple times.
  {:else if value === '1pattern'}
    all canes are the same, except the central cane.
  {:else if value === '2pattern'}
    around the central cane, there are circles made with the same cane, in a 1-2-1-2... pattern.
  {:else if value === '3pattern'}
    around the central cane, there are circles made with the same cane, in a 1-2-3-1-2-3... pattern.
  {:else if value === 'allGarlandsDifferent'}
    each concentric circle is made of different canes.
  {/if}
{:else if key === 'uniqueCanes'}
  {#if value === 1}
    There is <PrintVal {value} /> unique cane (present only once).
  {:else if value > 0}
    There are <PrintVal {value} /> unique canes (present only once).
  {:else}
    <PrintVal {value} /> - there are no unique canes.
  {/if}
{:else if key === 'differentCanes'}
  There are <PrintVal {value} /> different canes.
{:else if key === 'diversity'}
  The cane diversity (<i>differentCanes / numberOfCanes</i>) is <PrintVal {value} />.
  {#if value === 1}
    1 is the maximum.
  {/if}
{:else if key === 'hasSignatureCane'}
  <PrintVal {value} /> -
  {#if value === 'true'}
    the paperweight is signed.
  {:else}
    the paperweight is not signed.
  {/if}
{:else if key === 'hasSecondSignature'}
  <PrintVal {value} />
  {#if value === 'true'}
    - the paperweight has a double signature! Maybe it is a mistake...
  {/if}
{:else if key === 'hasRareSignature'}
  <PrintVal {value} />
  {#if value === 'true'}
    - the signature is non standard and rare.
  {/if}  
{:else if key === 'concentricCircles'}
  {#if value > 0}
    There are <PrintVal {value} /> concentric circles of canes around the central cane (including the central cane).
  {:else}
    <i>NA on {stats.layoutType} layout</i>
  {/if}
  
{:else if key === 'lastGarlandAlternate'}
  {#if stats.layoutType === 'concentric'}
    <PrintVal {value} /> - 
    {#if value === 'true'}
      the last circle of canes (closest to the border) is made of alternate canes (2 different canes alternated instead of just 1).
    {:else}
      the last circle of canes (closest to the border) does not alternate.
    {/if}
  {:else}
    <i>NA on {stats.layoutType} layout</i>
  {/if}

{:else}
  TODO
{/if}


<style>

</style>
